import React, {useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'

import Select from 'react-select'
import {globalsettingUpdate} from '../EmailToSmsSlice/EmailToSmsSlice'
import {getAllUserDetails} from '../../accounts/Overview/OverviewSlice/UserDetailsSlice'
import CreatableSelect from 'react-select/creatable'
import TagsInput from 'react-tagsinput'
import {KTSVG} from '../../../../../_metronic/helpers'
export const emailOption = [
  {value: '1', label: 'Recipient gets message from email Subject AND Body'},
  {value: '2', label: 'Recipient gets message from email Body ONLY'},
  {value: '3', label: 'Recipient gets message from email Subject ONLY'},
  {value: '4', label: 'Recipient gets message from the full email Body Content'},
]
const Globalsetting = ({show, handleClose}: any) => {
  const dispatch = useDispatch()
  const userValues = useSelector(getAllUserDetails)
  const [globalSetting, setGlobalSetting] = useState({
    emailSmsSubjectSetting: userValues?.emailSmsSubjectSetting,
    smsStartTag: userValues?.smsStartTag,
    smsEndTag: userValues?.smsEndTag,
  })

  const handleSubmit = () => {
    let data = {
      emailSmsSubjectSetting: globalSetting?.emailSmsSubjectSetting,
      smsStartTag: globalSetting?.smsStartTag,
      smsEndTag: globalSetting?.smsEndTag,
    }
    dispatch(globalsettingUpdate(data))
    handleClose()
  }

  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-487px'
        className='vh-100'
        show={show}
        onHide={handleClose}
      >
        <div className='modal-header'>
          <h1>Global Settings</h1>
          <div
            className='btn btn-icon btn-sm'
            onClick={() => {
              handleClose()
            }}
          >
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
        </div>
        <div className='modal-body p-10 '>
          <label className=' col-form-label fw-bold fs-6'>Content settings</label>

          <Select
            value={emailOption?.find(
              (key: any) => key?.value === globalSetting?.emailSmsSubjectSetting?.toString()
            )}
            onChange={(e: any) => {
              setGlobalSetting({...globalSetting, emailSmsSubjectSetting: e.value})
            }}
            options={[
              {value: '1', label: 'Recipient gets message from email Subject AND Body'},
              {value: '2', label: 'Recipient gets message from email Body ONLY'},
              {value: '3', label: 'Recipient gets message from email Subject ONLY'},
              {value: '4', label: 'Recipient gets message from the full email Body Content'},
            ]}
          />

          <label className=' col-form-label fw-bold fs-6'>
            SMS start tags
            <button
              className='bg-transparent'
              type='button'
              data-bs-toggle='tooltip'
              title='This tag will mark the start of the SMS, ignoring everything prior to it '
            >
              <i className='bi bi-info-circle-fill'></i>
            </button>
          </label>
          <TagsInput
            inputProps={{
              placeholder: 'Add your tags',
            }}
            onlyUnique
            className='form-control form-control-lg form-control-solid msg_tags mb-4'
            value={globalSetting?.smsStartTag}
            addOnBlur={true}
            onChange={(e: any) => {
              const val = e?.filter((key: any) => key?.trim() !== '')
              setGlobalSetting({...globalSetting, smsStartTag: val})
            }}
          />
          {/* <CreatableSelect
            // onCreateOption={handleCreate}
            isMulti
            // className='form-control form-control-lg form-control-solid mb-3'
            value={globalSetting?.smsStartTag}
          /> */}

          <label className=' col-form-label fw-bold fs-6'>
            SMS end tags
            <button
              className='bg-transparent'
              type='button'
              data-bs-toggle='tooltip'
              title='This tag will mark the end of the SMS, ignoring everything after it '
            >
              <i className='bi bi-info-circle-fill'></i>
            </button>
          </label>
          <TagsInput
            inputProps={{
              placeholder: 'Add your tags',
            }}
            onlyUnique
            className='form-control form-control-lg form-control-solid msg_tags mb-4'
            value={globalSetting?.smsEndTag}
            addOnBlur={true}
            onChange={(e: any) => {
              const val = e?.filter((key: any) => key?.trim() !== '')
              setGlobalSetting({...globalSetting, smsEndTag: val})
            }}
          />
          {/* <CreatableSelect
            // onCreateOption={handleCreate}
            isMulti
            // className='form-control form-control-lg form-control-solid mb-3'
            value={globalSetting?.smsEndTag}
            onChange={(e: any) => {
              setGlobalSetting({...globalSetting, smsEndTag: e})
            }}
          /> */}
          {/* <input
            value={globalSetting?.smsEndTag}
            onChange={(e: any) => {
              setGlobalSetting({...globalSetting, smsEndTag: e?.target?.value})
            }}
            name='name'
            type='text'
            className='form-control form-control-lg form-control-solid mb-3'
            placeholder='Add your tags'
          /> */}

          <div className='d-flex justify-content-end mt-10 border-top pt-6'>
            <div id='kt_drawer_chat_close'>
              <button
                onClick={handleClose}
                type='button'
                className='btn btn-md gray_bg_purple me-2'
              >
                Cancel
              </button>
            </div>

            <button
              onClick={handleSubmit}
              type='submit'
              className='btn btn-md btn-primary btn-blue fw-500   w-100px p-3 border border-primary'
            >
              <span className='indicator-label'>Add</span>
            </button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default Globalsetting
